async function addToCart(
  productId,
  quantity = 1,
  gotoCheckout = false,
  otherOptions = {},
  initiatorElement = null
) {
  let previousInnerHTML = "Add to Cart";
  try {
    if (initiatorElement) {
      initiatorElement.disabled = true;
      previousInnerHTML = initiatorElement.innerHTML;
      initiatorElement.innerHTML = "Adding...";
      initiatorElement.style.cursor = "wait";
    }

    const returnTo = gotoCheckout ? "checkout" : "cart";
    const clearCartResponse = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const checkoutUrl = `${
      window.location.origin
    }/cart/add?items[][id]=${productId}&items[][quantity]=${quantity}&items[][selling_plan]=${
      otherOptions?.selling_plan || ""
    }&return_to=/${returnTo}`;
    
     if (initiatorElement) {
      initiatorElement.disabled = false;
      initiatorElement.innerHTML = previousInnerHTML;
      initiatorElement.style.cursor = "pointer";
    }

    window.location.href = checkoutUrl;
  } catch (error) {
    if (initiatorElement) {
      initiatorElement.disabled = false;
      initiatorElement.innerHTML = previousInnerHTML;
      initiatorElement.style.cursor = "pointer";
    }
    console.error("Error adding to cart:", error);
    alert("Failed to add product to the cart: " + error.message);
  }
}
